import { render, staticRenderFns } from "./ArchiveCandidate.vue?vue&type=template&id=103a0826"
import script from "./ArchiveCandidate.vue?vue&type=script&lang=js"
export * from "./ArchiveCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports